import firebase from "firebase/app";
import 'firebase/firestore';

export class Impressao {

    
    constructor(dadosParaImpressao, marcacao, ocorre, sthora100,stminuto100,sthora50, stminuto50,stadicionalnhora,stadicionalnminuto,stcafe,stalmoco,stjanta,stpernoite,pagomotora) {
      this.dadosParaImpressao = dadosParaImpressao;
      this.marcacao = marcacao;
      this.ocorre=ocorre;
      this.sthora100=sthora100;
      this.stminuto100=stminuto100;
      this.sthora50=sthora50;
      this.stminuto50=stminuto50;
      this.stadicionalnhora=stadicionalnhora;
      this.stadicionalnminuto=stadicionalnminuto;
      this.stcafe=stcafe;
      this.stalmoco=stalmoco;
      this.stjanta=stjanta;
      this.stpernoite=stpernoite;
      this.stvalortotal=pagomotora;
    }  
  
    async PreparaDocumento() {
      const corpoDocumento = this.CriaCorpoDocumento();
      const documento = this.GerarDocumento();
      return documento;
    }
  
    CriaCorpoDocumento() {
      
     /* const body = this.dadosParaImpressao.map((prod) => {
        return [
          { text: prod.nome, fontSize: 8 },
          { text: prod.qtdEstoque, fontSize: 8 },
          { text: prod.qtdVendido, fontSize: 8 },
        ];
      });*/

      const body = (() => {
        return [{
            
        }];
      })
  
     
  
      let content = [body];
      
      return content;
    }
    
    
 GerarDocumento() {
        

        console.log(this.dadosParaImpressao.props[0].motorista.label);
        console.log(this.custos);
      const documento = {
        pageSize: 'A4',
        //pageMargins: [14, 53, 14, 48],
        pageOrientation: 'landscape',
        info: {
            title: 'Diário de Bordo',
          },
        content: [
       

            {
                alignment: 'center',
                columns: [
                
    
                        {text:'Diário de Bordo' , style: 'header' },
                            
                           
                        
                ] 
            },
            
        {
                    alignment: 'center',
                style: 'tableExample',
                
                
                table: {
                    
                    body: [
                        ['Empresa', {colSpan: 3, rowSpan: 1, text: 'PEDRO REGINALDO DE ALBERNAZ FARIA E FAGUNDES LTDA - ME'}, '','','Diário de bordo nº', this.dadosParaImpressao.props[0].nsolicitacao],
                        ['Cnpj',{colSpan: 3, rowSpan: 1, text: '10.439.655/0001-14'},'','','Ordem de Trânsito', this.dadosParaImpressao.props[0].nsolicitacao],
                        ['Motorista', {colSpan: 3, rowSpan: 1, text: this.dadosParaImpressao.props[0].motorista.label},'','','De:',this.dadosParaImpressao.props[0].localsaida.description],
                        ['CNH',this.dadosParaImpressao.props[0].motorista.cnh,'Cargo:',this.dadosParaImpressao.props[0].motorista.categoriamotorista.label,'Para:',this.dadosParaImpressao.props[0].localdestino.description],
                        ['CPF',this.dadosParaImpressao.props[0].motorista.cpf,'Fone:',this.dadosParaImpressao.props[0].motorista.telefone,' Veículo/Placa:',this.dadosParaImpressao.props[0].veiculo.label],
                        
                    ]
                }
            },

            {text:'Marcações' , style: 'subheader' },
            

           this.marcacao.map((item)=>{
               return[{
                columns: [
                
    
                    {text:item.datahora},
                    {text:item.marcacao },
                    {text:'' },
                    
            ] 
        }
                
            ];
            
            
           }),
            
           
            
           
            
            {
                
                columns: [
                
                        {
                            alignment: 'center',
                style: 'tableExample',
                
                
                table: {
                    
                    body: [
                      
                        [{colSpan: 10, rowSpan: 1, text: 'Saldo Total - (Horas extras e diárias)'},'','','','','','','','',''],
                        [{colSpan: 2, rowSpan: 1, text:'Hora Extra 50% (H:M)'},'',{colSpan: 2, rowSpan: 1, text:'Hora Extra 100% (H:M)'},'',{colSpan: 2, rowSpan: 1, text:'Adicional Noturno (H:M)'},'','Café (qtd)',  'Almoço (qtd)', 'Janta (qtd)','Pernoite (qtd)'],
                        [this.sthora50, this.stminuto50,this.sthora100,this.stminuto100,this.stadicionalnhora,this.stadicionalnminuto,this.stcafe,this.stalmoco,this.stjanta,this.stpernoite],
                        
                                              
                    
                        
                    ]
                }
            },
                        { alignment: 'center',
                        text:[
                            
                            {text:'Total Pago R$ ', style: 'subheader',}, , 
                            {text:this.stvalortotal, style: 'subheader',},
                            {text:'\n\n De acordo:\n', style: 'subheader', },
                            {text:'\n' },
                            {text:'Motorista\n' },
                            {text:this.dadosParaImpressao.props[0].motorista.label },
                            {text:'\n\n' },
                            /*{text:'Supervisor:\n' },
                            {text:'Rosane Amorim Roque\n' },
                            {text:'Matrícula: ' },
                            {text:'9894227\n' },*/

                            
                            {text:'\nPROINFRA - UFSM\n' },
                            {text:this.dadosParaImpressao.usernome },
                            {text:'\n SIAPE: ' },
                            {text:this.dadosParaImpressao.usersiape },
                            
                            ]},
                            
                           
                        
                ] 
                    },
                    

                        {text:'Ocorrências da Viagem' , style: 'subheader' },
            
                        this.ocorre.map((item)=>{
                            return[{
                             columns: [
                             
                 
                                 {text:item.datahora},
                                 {text:item.nomeassina },
                                 {text:item.ocorrencia },
                                 
                         ] 
                     }
                             
                         ];
                         
                         
                        }),
    
    
    
            
        ],
      
          styles: {
            header: {
                fontSize: 13,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 12,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: 'black'
            }
        },
        defaultStyle: {
            // alignment: 'justify'
            fontSize: 11,
        }
  
    };
      return documento;
    }
  }